import React, { useState } from 'react'
import moment from 'moment'

import { authorization } from '../../../../../../Module/Auth/Auth'
import { SectionWrapper } from '../../../../../../Components/Section/SectionWrapper'
import { SubmitButtonBlock } from '../../../../../../Components/Form/SubmitButton/SubmitButtonBlock'
import SubmitButton from '../../../../../../Components/Form/SubmitButton'
import { SectionTitle } from '../../../../../../Components/Section/SectionTitle'
import { Input } from './../../../../../../Components/Form/Input'
import { Row, Col } from 'react-bootstrap'
import { SelectDashboard } from './../../../../../../Components/Form/SelectDashboard'
import { Checkbox } from './../../../../../../Components/Form/Checkbox'
import Note from './../../../../../../Components/Note'
import ConfirmableCheckbox from '../../../../../../Components/ConfirmableCheckbox/container/ConfirmableCheckbox'
import { CityMap } from '../../../../../../Components/City/CityMap'
import { number, roundNumber, required } from 'Utils/Validators/formValidation'
import Form from 'Components/Form'
import { getDefaultSpySettingByCountry } from '../../util/constants'

// Copied over from previous code
const timezones = moment.tz.names().map(t => ({ label: t, value: t }))

// Copied over from previous code
const times = [...Array(24).keys()].reduce((agg, time) => {
  const hour = moment(time, 'h')
  hour.set('seconds', 0)
  agg.push({
    value: hour.format('HH:mm:ss'),
    label: `${hour.format('h:mm a')}`,
  })

  hour.add(30, 'minutes')
  agg.push({
    value: hour.format('HH:mm:ss'),
    label: `${hour.format('h:mm a')}`,
  })

  return agg
}, [])

const UIBlocker = props => (
  <div
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'white',
      display: 'flex',
    }}
  >
    <div style={{ margin: 'auto', textAlign: 'center' }}>{props.children}</div>
  </div>
)

const EditCityDetailsView = props => {
  const { cityData, isLoaded } = props
  const isAdmin = authorization.isAdmin()
  const [formData, setFormData] = useState({
    name: cityData ? cityData.name : null,
    pickupInformationURL: cityData ? cityData.pickupInformation : null,
    cbdRadius: cityData ? cityData.cbdRadius : null,
    surgeInterval: cityData ? cityData.surgeInterval : null,
    newcomersMissionsLimit: cityData
      ? cityData.newcomersMissionsLimit
      : props.newcomersMissionsLimit,
    timezone: cityData ? cityData.timezone : null,
    checkinRadius: cityData ? cityData.checkinRadius : null,
    status: cityData ? cityData.statusV2 : props.status,
    payHourly: cityData ? cityData.payHourly : null,
    recruitmentOnHold: cityData ? cityData.recruitmentOnHold : null,
    morningCheckInTimeBefore: cityData
      ? cityData.morningCheckingTimeBefore
      : props.morningCheckingTimeBefore,
    morningCheckInTimeAfter: cityData
      ? cityData.morningCheckingTimeAfter
      : props.morningCheckInTimeAfter,
    lunchCheckInTime: cityData
      ? cityData.lunchCheckingTime
      : props.lunchCheckInTime,
    lunchCheckInTimeBefore: cityData
      ? cityData.lunchCheckingTimeBefore
      : props.lunchCheckInTimeBefore,
    lunchCheckInTimeAfter: cityData
      ? cityData.lunchCheckingTimeAfter
      : props.lunchCheckInTimeAfter,
    afternoonCheckInTime: cityData
      ? cityData.afternoonCheckingTime
      : props.afternoonCheckInTime,
    afternoonCheckInTimeBefore: cityData
      ? cityData.afternoonCheckingTimeBefore
      : props.afternoonCheckInTimeBefore,
    afternoonCheckInTimeAfter: cityData
      ? cityData.afternoonCheckingTimeAfter
      : props.afternoonCheckInTimeAfter,
    countryId: cityData ? cityData.countryId : null,
    teamLeaderEnabled: cityData && isAdmin ? cityData.teamLeaderEnabled : null,
    cityLocation: cityData ? cityData.location : null,
    recruitmentCalendarId: cityData ? cityData.recruitmentCalendarId : null,
    onboardingLocation: cityData ? cityData.onboardingLocation : null,
    onboardingUrl: cityData ? cityData.onboardingUrl : null,
  })

  const spySettings = cityData && cityData.spySettings
  const defaultSettings = getDefaultSpySettingByCountry(
    cityData && cityData.country && cityData.country.code,
  )

  const [spySettingsData, setSpySettingsData] = useState({
    hourlyRate: spySettings
      ? spySettings.hourlyRate
      : defaultSettings.hourlyRate,
    maxBudgetPerWeek: spySettings
      ? spySettings.maxBudgetPerWeek
      : defaultSettings.maxBudgetPerWeek,
    travelAllowancePerMission: spySettings
      ? spySettings.travelAllowancePerMission
      : defaultSettings.travelAllowancePerMission,
    travelAllowanceCap: spySettings
      ? spySettings.travelAllowanceCap
      : defaultSettings.travelAllowanceCap,
    durationHandToHandMission: spySettings
      ? spySettings.durationHandToHandMission
      : defaultSettings.durationHandToHandMission,
    durationLetterboxMission: spySettings
      ? spySettings.durationLetterboxMission
      : defaultSettings.durationLetterboxMission,
    durationShift: spySettings
      ? spySettings.durationShift
      : defaultSettings.durationShift,
    missionsPerShift: spySettings
      ? spySettings.missionsPerShift
      : defaultSettings.missionsPerShift,
  })

  const editCityLocation = newLocation => {
    changeProp('cityLocation', newLocation)
  }

  var changeProp = function(prop, value) {
    return setFormData(formData => ({
      ...formData,
      [prop]: value,
    }))
  }

  const editSpySettingsProp = (prop, value) => {
    setSpySettingsData({
      ...spySettingsData,
      [prop]: value ? Number(value) : null,
    })
  }

  const onSubmitSpySettings = (form, isValid) => {
    if (isValid) {
      props.updateCitySpySettings(spySettingsData)
    }
  }

  if (!isLoaded) return 'Loading...'

  return (
    <div>
      <SectionWrapper className="section-wrapper city-details">
        <SectionTitle className="section-title">City Details</SectionTitle>
        {props.enableEditCountry && isAdmin ? (
          <Row>
            <Col xs={3}>
              <SelectDashboard
                label="Country"
                onChange={(e, k, v) => changeProp('countryId', v)}
                options={props.countries.map(o => ({
                  value: o.id,
                  label: o.name,
                }))}
                input={{
                  value: formData.countryId,
                }}
              />
            </Col>
          </Row>
        ) : null}
        <Row>
          {isAdmin && (
            <Col xs={3}>
              <Input
                label="City Name"
                value={formData.name}
                onChange={e => changeProp('name', e.target.value)}
              />
            </Col>
          )}
          <Col xs={3}>
            <Input
              label="Pickup information URL"
              value={formData.pickupInformationURL}
              onChange={e => changeProp('pickupInformationURL', e.target.value)}
            />
          </Col>
          {isAdmin && (
            <Col xs={3}>
              <Input
                label="Radius"
                value={String(formData.cbdRadius || '')}
                onChange={e =>
                  changeProp(
                    'cbdRadius',
                    e.target.value == '' ? null : Number(e.target.value),
                  )
                }
              />
            </Col>
          )}
          {isAdmin && (
            <Col xs={3}>
              <Input
                label="Surge Interval"
                value={String(formData.surgeInterval || '')}
                onChange={e =>
                  changeProp(
                    'surgeInterval',
                    e.target.value == '' ? null : Number(e.target.value),
                  )
                }
              />
            </Col>
          )}
        </Row>
        <Row>
          <Col xs={3}>
            <SelectDashboard
              label="1 week cap for 1st time users"
              onChange={(e, k, v) => {
                return changeProp('newcomersMissionsLimit', v)
              }}
              options={[
                { label: 'No Limit', value: null },
                { label: '1', value: 1 },
                { label: '2', value: 2 },
                { label: '3', value: 3 },
                { label: '4', value: 4 },
                { label: '5', value: 5 },
                { label: '6', value: 6 },
                { label: '7', value: 7 },
                { label: '8', value: 8 },
                { label: '9', value: 9 },
                { label: '10', value: 10 },
              ]}
              input={{
                value: formData.newcomersMissionsLimit,
              }}
            />
          </Col>
          {isAdmin && (
            <Col xs={3}>
              <SelectDashboard
                label="Timezone"
                onChange={(e, k, v) => changeProp('timezone', v)}
                options={timezones}
                input={{
                  disabled: !props.enableChangeTimezone,
                  value: formData.timezone,
                }}
              />
              <br />
              <Note>
                Its important to set this correctly else the displayed mission
                times will be incorrect.
              </Note>
            </Col>
          )}
          {isAdmin && (
            <Col xs={3}>
              <Input
                label="Checkin Radius (meters)"
                value={String(formData.checkinRadius || '')}
                onChange={e =>
                  changeProp(
                    'checkinRadius',
                    e.target.value == '' ? null : Number(e.target.value),
                  )
                }
              />
            </Col>
          )}
          {isAdmin && (
            <Col xs={3}>
              <SelectDashboard
                label="Status"
                onChange={(e, k, v) => changeProp('status', v)}
                options={[
                  { label: 'Active', value: 'ACTIVE' },
                  { label: 'Archived', value: 'ARCHIVED' },
                ]}
                input={{
                  value: formData.status,
                }}
              />
            </Col>
          )}
        </Row>
        <Row xs={3}>
          {isAdmin && (
            <Col xs={3}>
              <Checkbox
                label="Pay Hourly"
                input={{
                  value: formData.payHourly ? 'checked' : undefined,
                  onChange: e =>
                    changeProp('payHourly', e.target.value !== 'checked'),
                }}
              />
              <br />
              <Note>
                Be very careful before enabling this. Paying hourly is seen in
                the eyes of Government bodies as treating workers as employees
                and not contractors. Hourly pay will be payout ÷ 3 (surge still
                applies).
              </Note>
            </Col>
          )}
          <Col xs={3}>
            <Checkbox
              label="Recruitment on hold"
              input={{
                value: formData.recruitmentOnHold ? 'checked' : undefined,
                onChange: e =>
                  changeProp('recruitmentOnHold', e.target.value !== 'checked'),
              }}
            />
          </Col>
          {isAdmin && (
            <Col xs={3}>
              <ConfirmableCheckbox
                label="Team Leader Enabled"
                value={formData.teamLeaderEnabled}
                note={`Enabling this feature changes brand ambassador dynamics
              substantially. Existing brand ambassadors will only be able to
              book missions where a team leader has booked an identical mission
              at the same time and location. You can promote brand ambassadors
              to team leaders on the brand ambassador details page.`}
                confirmationModal={{
                  title: 'Warning',
                  body: (
                    <ul>
                      <li>Seek legal advice before enabling.</li>
                      <li>
                        Enabling the Team Leader feature changes how Brand
                        Ambassadors interact with Oppizi and each other.
                      </li>
                      <li>
                        Team Leaders are able to book missions on their own or
                        to be completed with other Brand Ambassadors.
                      </li>
                      <li>
                        Team Leaders are responsible for picking up flyers and
                        invetory on behalf of themselves and any other Brand
                        Ambassador booked on the same mission.
                      </li>
                      <li>
                        Existing Brand Ambassadors will only be able to view and
                        book missions which have a Team Leader already booked or
                        assigned to it.
                      </li>
                      <li>
                        You can promote Brand Ambassadors to team leaders on the
                        brand ambassador details page.
                      </li>
                    </ul>
                  ),
                  onConfirm: val => changeProp('teamLeaderEnabled', val),
                  showOnDisable: false,
                }}
              />
            </Col>
          )}
          <Col xs={3}>
            <Input
              label="Recruitment Calendar Integration Link"
              value={formData.recruitmentCalendarId}
              onChange={e =>
                changeProp('recruitmentCalendarId', e.target.value)
              }
            />
          </Col>
          <Col xs={3}>
            <Input
              label="Onboarding Location"
              value={formData.onboardingLocation}
              onChange={e => changeProp('onboardingLocation', e.target.value)}
            />
          </Col>
          <Col xs={3}>
            <Input
              label="Online Meeting URL"
              value={formData.onboardingUrl}
              onChange={e => changeProp('onboardingUrl', e.target.value)}
            />
            <br />
            <Note>Format: meet.google.com/aaa-bbbb-ccc</Note>
          </Col>
        </Row>
        <React.Fragment>
          <SectionTitle>Location</SectionTitle>
          <Note>Drag the pin to the location of the city.</Note>
          <CityMap
            cityLocation={formData.cityLocation}
            editCityLocation={editCityLocation}
          />
        </React.Fragment>

        {isAdmin && (
          <React.Fragment>
            <br />
            <br />
            <br />
            <SectionTitle className="section-title">Mission Times</SectionTitle>

            <Row>
              <Col xs={3}>
                <Input disabled label="Mission" value="Morning" />
              </Col>
              <Col xs={3} />
              <Col xs={3}>
                <Input
                  label="Allowed time before"
                  value={formData.morningCheckInTimeBefore}
                  onChange={e =>
                    changeProp(
                      'morningCheckInTimeBefore',
                      e.target.value == '' ? null : Number(e.target.value),
                    )
                  }
                />
              </Col>
              <Col xs={3}>
                <Input
                  label="Allowed time after"
                  value={formData.morningCheckInTimeAfter}
                  onChange={e =>
                    changeProp(
                      'morningCheckInTimeAfter',
                      e.target.value == '' ? null : Number(e.target.value),
                    )
                  }
                />
              </Col>
            </Row>
            <Row>
              <Col xs={3}>
                <Input disabled label="Mission" value="Lunch" />
              </Col>
              <Col xs={3}>
                <SelectDashboard
                  label="Starting time"
                  options={times}
                  onChange={(e, k, v) => changeProp('lunchCheckInTime', v)}
                  input={{
                    value: formData.lunchCheckInTime,
                  }}
                />
              </Col>
              <Col xs={3}>
                <Input
                  label="Allowed time before"
                  value={formData.lunchCheckInTimeBefore}
                  onChange={e =>
                    changeProp(
                      'lunchCheckInTimeBefore',
                      e.target.value == '' ? null : Number(e.target.value),
                    )
                  }
                />
              </Col>
              <Col xs={3}>
                <Input
                  label="Allowed time after"
                  value={formData.lunchCheckInTimeAfter}
                  onChange={e =>
                    changeProp(
                      'lunchCheckInTimeAfter',
                      e.target.value == '' ? null : Number(e.target.value),
                    )
                  }
                />
              </Col>
            </Row>
            <Row>
              <Col xs={3}>
                <Input disabled label="Mission" value="Afternoon" />
              </Col>
              <Col xs={3}>
                <SelectDashboard
                  label="Starting time"
                  options={times}
                  onChange={(e, k, v) => changeProp('afternoonCheckInTime', v)}
                  input={{
                    value: formData.afternoonCheckInTime,
                  }}
                />
              </Col>
              <Col xs={3}>
                <Input
                  label="Allowed time before"
                  value={formData.afternoonCheckInTimeBefore}
                  onChange={e =>
                    changeProp(
                      'afternoonCheckInTimeBefore',
                      e.target.value == '' ? null : Number(e.target.value),
                    )
                  }
                />
              </Col>
              <Col xs={3}>
                <Input
                  label="Allowed time after"
                  value={formData.afternoonCheckInTimeAfter}
                  onChange={e =>
                    changeProp(
                      'afternoonCheckInTimeAfter',
                      e.target.value == '' ? null : Number(e.target.value),
                    )
                  }
                />
              </Col>
            </Row>
          </React.Fragment>
        )}

        <SubmitButtonBlock float="left">
          <SubmitButton
            value="Save"
            onClick={function(e) {
              e.preventDefault()
              return props.updateCity(formData)
            }}
          />
        </SubmitButtonBlock>
      </SectionWrapper>

      <SectionWrapper className="section-wrapper">
        <SectionTitle className="section-title">Spy Details</SectionTitle>
        <Form onSubmit={onSubmitSpySettings}>
          <Row>
            <Col xs={3}>
              <Input
                label="Spy hourly rate in local CURR"
                initValue={spySettingsData.hourlyRate}
                onChange={e =>
                  editSpySettingsProp('hourlyRate', e.target.value)
                }
                name="hourlyRate"
                validator={[required, number]}
              />
              <br />
              <Note>in local currency</Note>
            </Col>
            <Col xs={3}>
              <Input
                label="Max spy budget per week"
                initValue={spySettingsData.maxBudgetPerWeek}
                onChange={e =>
                  editSpySettingsProp('maxBudgetPerWeek', e.target.value)
                }
                name="maxBudgetPerWeek"
              />
              <br />
              <Note>
                if blank = no limit
                <br />
                if 0 = spies can’t book mission
              </Note>
            </Col>
            <Col xs={3}>
              <Input
                label="Travel allowance per spy mission"
                initValue={spySettingsData.travelAllowancePerMission}
                onChange={e =>
                  editSpySettingsProp(
                    'travelAllowancePerMission',
                    e.target.value,
                  )
                }
                validator={[required, number]}
                name="travelAllowancePerMission"
              />
              <br />
              <Note>mission = 1 pair of BA to spy on</Note>
            </Col>
            <Col xs={3}>
              <Input
                label="Travel allowance cap"
                initValue={spySettingsData.travelAllowanceCap}
                onChange={e =>
                  editSpySettingsProp('travelAllowanceCap', e.target.value)
                }
                name="travelAllowanceCap"
              />
              <br />
              <Note>
                if blank = no limit
                <br />
                in local currency,
                <br />
                Some cities have weekly unlimited trips card, so CM should cap
                the travel allowance to the value of this card , could be no
                cap.
              </Note>
            </Col>
          </Row>

          <Row>
            <Col xs={3}>
              <Input
                label="Duration H2H Spy mission"
                initValue={spySettingsData.durationHandToHandMission}
                onChange={e =>
                  editSpySettingsProp(
                    'durationHandToHandMission',
                    e.target.value,
                  )
                }
                validator={[required, number, roundNumber]}
                name="durationHandToHandMission"
              />
              <br />
              <Note>in minutes 1 mission = 1 BA</Note>
            </Col>
            <Col xs={3}>
              <Input
                label="Duration LetterBox Spy mission"
                initValue={spySettingsData.durationLetterboxMission}
                onChange={e =>
                  editSpySettingsProp(
                    'durationLetterboxMission',
                    e.target.value,
                  )
                }
                validator={[required, number, roundNumber]}
                name="durationLetterboxMission"
              />
              <br />
              <Note>in minutes 1 mission = 1 BA</Note>
            </Col>
            <Col xs={3}>
              <Input
                label="Duration of a spy shift "
                initValue={spySettingsData.durationShift}
                onChange={e =>
                  editSpySettingsProp('durationShift', e.target.value)
                }
                validator={[required, number, roundNumber]}
                name="durationShift"
              />
            </Col>
            <Col xs={3}>
              <Input
                label="Mission per spy shift"
                initValue={spySettingsData.missionsPerShift}
                onChange={e =>
                  editSpySettingsProp('missionsPerShift', e.target.value)
                }
                validator={[required, number, roundNumber]}
                name="missionsPerShift"
              />
              <br />
              <Note>
                {spySettingsData.missionsPerShift
                  ? `Spy will have to book ${
                      spySettingsData.missionsPerShift
                    } locations to complete their shift`
                  : null}
              </Note>
            </Col>
          </Row>

          <SubmitButtonBlock float="left">
            <SubmitButton
              value="Save"
              onClick={function(e) {
                e.preventDefault()
              }}
            />
          </SubmitButtonBlock>
          {props.isSaving ? <UIBlocker>Loading...</UIBlocker> : null}
        </Form>
      </SectionWrapper>
      {props.isSaving ? <UIBlocker>Loading...</UIBlocker> : null}
    </div>
  )
}

export default EditCityDetailsView



// WEBPACK FOOTER //
// ./src/Containers/Form/City/CityAddEdit/Edit/EditCityDetails/View.js